const RenderOnAnonymous = ({ userService,children }) => (!userService.isLoggedIn()) ? children : <></>;

export default RenderOnAnonymous